import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  adminprofileDetails: null,
  error: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    fetchProfileStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchProfileSuccess(state, action) {
      state.isLoading = false;
      state.adminprofileDetails = action.payload;
      state.error = null;
    },
    fetchProfileFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    editProfileStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    editProfileSuccess(state, action) {
      state.isLoading = false;
      state.adminprofileDetails = {
        ...state.adminprofileDetails,
        ...action.payload,
      };
    },
    editProfileFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchProfileFailure,
  fetchProfileSuccess,
  fetchProfileStart,
  editProfileFailure,
  editProfileSuccess,
  editProfileStart,
} = profileSlice.actions;

export default profileSlice.reducer;
